const TopContentStyle = {
  containerHeight: 80,
  dividerHeight: 1,
};

export default TopContentStyle;
